import { twMerge } from "tailwind-merge";

export const RoleTableDataStatus = ({ status }: { status: boolean }) => (
  <div className={twMerge("flex flex-col", status ? "text-success" : "text-error")}>
    <span className="font-bold">{status ? "Active" : "Inactive"}</span>
    <span>{status ? "*Assigned to at least one user" : "*Not assigned to any users"}</span>
  </div>
);
